import AdminHelpscoutSettings from './AdminHelpscoutSettings';

export default AdminHelpscoutSettings;
